import { ref } from 'vue';

const termsText = ref("Terms and conditions");
const modalOpen = ref(false);
function setTermsText(text) {
  termsText.value = text;
}
function toggleModal() {
  modalOpen.value = !modalOpen.value;
}
function resetModal() {
  modalOpen.value = false;
  termsText.value = "";
}

export { termsText as a, modalOpen as m, resetModal as r, setTermsText as s, toggleModal as t };
//# sourceMappingURL=useModal.CtQMkYkB.js.map
